import { upperFirst, camelCase } from 'lodash';

var styles = {"alignLeft":"HU5d3","textWrapNowrap":"_57uJc","alignRight":"tt3PG","alignCenter":"OFZVf","sizeFullWidth":"C04iY","renderedInTable":"l6cVR","sizeOriginal":"_5lrON","sizeContent":"_2TAtK","sizeSmall":"_1WLf4","sizeSmallCenter":"g8NZJ","flex":"mlNhk","atomic":"dzyBu","anchor":"CDZmb","embed":"_2mVj-","horizontalScrollbar":"ixmjh","pluginContainerMobile":"mv48Z"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};

export { getSizeClassName as a, getTextWrapClassName as b, alignmentClassName as c, sizeClassName as d, getAlignmentClassName as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-3d7a9427.js.map
